<template>
  <div class="info-button-delete" @click="remove">
    お知らせの削除
  </div>
</template>

<script>
export default {
  methods: {
    remove: function () {
      if (window.confirm('本当に削除しますか？')) {
        this.$router.go(-1)
        this.$store.dispatch('info/deleteInfo')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.info-button-delete {
  @include button-ol-danger;
}
</style>
